export enum PublicBadgeDetailsParams {
  badgeUuid = "badgeUuid",
}
